<template>
  <div class="page-wrapper reset-password-success-wrapper job-expired-wrapper">
    <h1 class="title">{{ $t('jobDetail.jobClosed') }}</h1>
    <p class="success-tip" v-html="$t('jobDetail.jobClosedDescription',{companyName:company.i18n_name})"></p>
    <div class="btn-group">
      <div class="background-pic"></div>
      <router-link class="submit-btn" :to="`/recruiting/company/${company.id}/branding`">{{ $t('jobDetail.viewCompany') }}</router-link>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    company: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
